import { getStyleProp } from "ngx-core-services";

import { DeviceCategoryId, DeviceAttributeId, DeviceAttributes } from ".";

export const categoryLabels: Record<DeviceCategoryId, string> = {
  strings: 'Strings',
  mppt: 'MPPT',
  temperature: 'Temperature',
  grid: 'Grid',
  battery: 'Battery',
  default: 'Plant',
  external: 'External Production',
  solarimeter: 'Solarimeter',
};

export const attributeLabels: Record<DeviceAttributeId, string> = {
  TI: 'Heatsink Temperature',
  TB1: 'Temperature Env Battery 1',
  TB2: 'Temperature Env Battery 2',
  FC1: 'Current Output R',
  FC2: 'Current Output S',
  FC3: 'Current Output T',
  FT1: 'Voltage Output R',
  FT2: 'Voltage Output S',
  FT3: 'Voltage Output T',
  FR: 'Grid Frequency',
  BC1: 'Battery Current 1',
  BC2: 'Battery Current 2',
  BT1: 'Battery Voltage 1',
  BT2: 'Battery Voltage 2',
  BN1: 'Charge Cycles Battery 1',
  BN2: 'Charge Cycles Battery 2',
  P_DC_TOT: 'Generated Power',
  P_B_AGGR: 'Power Battery',
  P_EXP: 'Power Export',
  P_LOAD: 'Consumption Power',
  P_EXP_POS: 'Imported Power',
  P_EXT: 'External Power',
  P_EXP_NEG: 'Exported Power',
  P_B_AGGR_POS: 'Charging Power',
  P_B_AGGR_NEG: 'Discharging Power',
  BP: 'State of Charge Batteries',
  BP1: 'State of Charge Battery 1',
  BP2: 'State of Charge Battery 2',
  SOL_IRR: 'Irradiance',
  SOL_TEMP: 'Temperature',
  MP1: '',
  MP2: '',
  MP3: '',
  MP4: '',
  MP5: '',
  MP6: '',
  MP7: '',
  MP8: '',
  MP9: '',
  MP10: '',
  MP11: '',
  MP12: '',
  MP13: '',
  MP14: '',
  MP15: '',
  MP16: '',
  MT1: '',
  MT2: '',
  MT3: '',
  MT4: '',
  MT5: '',
  MT6: '',
  MT7: '',
  MT8: '',
  MT9: '',
  MT10: '',
  MT11: '',
  MT12: '',
  MT13: '',
  MT14: '',
  MT15: '',
  MT16: '',
  MC1: '',
  MC2: '',
  MC3: '',
  MC4: '',
  MC5: '',
  MC6: '',
  MC7: '',
  MC8: '',
  MC9: '',
  MC10: '',
  MC11: '',
  MC12: '',
  MC13: '',
  MC14: '',
  MC15: '',
  MC16: '',
  SC1: '',
  SC2: '',
  SC3: '',
  SC4: '',
  SC5: '',
  SC6: '',
  SC7: '',
  SC8: '',
  SC9: '',
  SC10: '',
  SC11: '',
  SC12: '',
  SC13: '',
  SC14: '',
  SC15: '',
  SC16: '',
  SC17: '',
  SC18: '',
  SC19: '',
  SC20: '',
  SC21: '',
  SC22: '',
  SC23: '',
  SC24: '',
  SC25: '',
  SC26: '',
  SC27: '',
  SC28: '',
  SC29: '',
  SC30: '',
  SC31: '',
  SC32: '',
};

const MAX_STRINGS = 32;

for (let index = 1; index <= MAX_STRINGS; index++) {
  attributeLabels[`SC${index}` as DeviceAttributeId] = `String Current ${index}`;
  attributeLabels[`MP${index}` as DeviceAttributeId] = `MPPT Power ${index}`;
  attributeLabels[`MT${index}` as DeviceAttributeId] = `MPPT Voltage ${index}`;
  attributeLabels[`MC${index}` as DeviceAttributeId] = `MPPT Current ${index}`;
}

export const deviceAttributes: DeviceAttributes[] = [
  {
    scope: [],
    phase: [],
    id: 'TI',
    categoryId: 'temperature',
    graphOpts: {
      unit: '°C',
    }
  }, {
    scope: ['hybrid', 'hybrid-3ph'],
    phase: [],
    id: 'TB1',
    categoryId: 'temperature',
    graphOpts: {
      unit: '°C',
    }
  }, {
    scope: ['hybrid-3ph'],
    phase: ['three-phase'],
    id: 'TB2',
    categoryId: 'temperature',
    graphOpts: {
      unit: '°C',
    }
  }, {
    scope: [],
    phase: [],
    id: 'FC1',
    categoryId: 'grid',
    graphOpts: {
      unit: 'A',
    }
  }, {
    scope: [],
    phase: ['three-phase'],
    id: 'FC2',
    categoryId: 'grid',
    graphOpts: {
      unit: 'A',
    }
  }, {
    scope: [],
    phase: ['three-phase'],
    id: 'FC3',
    categoryId: 'grid',
    graphOpts: {
      unit: 'A',
    }
  }, {
    scope: [],
    phase: [],
    id: 'FT1',
    categoryId: 'grid',
    graphOpts: {
      unit: 'V',
    }
  }, {
    scope: [],
    phase: ['three-phase'],
    id: 'FT2',
    categoryId: 'grid',
    graphOpts: {
      unit: 'V',
    }
  }, {
    scope: [],
    phase: ['three-phase'],
    id: 'FT3',
    categoryId: 'grid',
    graphOpts: {
      unit: 'V',
    }
  }, {
    scope: [],
    phase: [],
    id: 'FR',
    categoryId: 'grid',
    graphOpts: {
      unit: 'Hz',
    }
  }, {
    scope: ['hybrid', 'hybrid-3ph', 'storage'],
    phase: [],
    id: 'P_EXT',
    categoryId: 'external',
    graphOpts: {
      unit: 'kW',
      color: getStyleProp('--orange-500'),
      transformUnitFn: (value: number) => Number((value / 1000).toFixed(2))
    }
  },{
    scope: ['hybrid', 'hybrid-3ph', 'storage'],
    phase: [],
    id: 'BC1',
    categoryId: 'battery',
    graphOpts: {
      unit: 'A',
    }
  }, {
    scope: ['hybrid', 'hybrid-3ph', 'storage'],
    phase: ['three-phase'],
    id: 'BC2',
    categoryId: 'battery',
    graphOpts: {
      unit: 'A',
    }
  }, {
    scope: ['hybrid', 'hybrid-3ph', 'storage'],
    phase: [],
    id: 'BT1',
    categoryId: 'battery',
    graphOpts: {
      unit: 'V',
    }
  }, {
    scope: ['hybrid', 'hybrid-3ph', 'storage'],
    phase: ['three-phase'],
    id: 'BT2',
    categoryId: 'battery',
    graphOpts: {
      unit: 'V',
    }
  }, {
    scope: ['hybrid', 'hybrid-3ph', 'storage'],
    phase: [],
    id: 'BN1',
    categoryId: 'battery',
    graphOpts: {
      noArea: true,
      unit: '#',
    }
  }, {
    scope: ['hybrid', 'hybrid-3ph', 'storage'],
    phase: ['three-phase'],
    id: 'BN2',
    categoryId: 'battery',
    graphOpts: {
      noArea: true,
      unit: '#',
    }
  }
];

for (let index = 1; index <= MAX_STRINGS; index++) {
  deviceAttributes.push({
    scope: [],
    phase: [],
    id: `SC${index}` as DeviceAttributeId,
    categoryId: 'strings',
    graphOpts: {
      unit: 'A',
    }
  });
  deviceAttributes.push({
    scope: [],
    phase: [],
    id: `MP${index}` as DeviceAttributeId,
    categoryId: 'mppt',
    graphOpts: {
      unit: 'kW',
      transformUnitFn: (value: number) => Number((value / 1000).toFixed(2))
    }
  });
  deviceAttributes.push({
    scope: [],
    phase: [],
    id: `MT${index}` as DeviceAttributeId,
    categoryId: 'mppt',
    graphOpts: {
      unit: 'V',
    }
  });
  deviceAttributes.push({
    scope: [],
    phase: [],
    id: `MC${index}` as DeviceAttributeId,
    categoryId: 'mppt',
    graphOpts: {
      unit: 'A',
    }
  });
}

export const powerGenerationAttributes: DeviceAttributes[] = [
  {
    scope: [],
    phase: [],
    id: 'P_DC_TOT',
    categoryId: 'default',
    graphOpts: {
      unit: 'kW',
      color: getStyleProp('--orange-500'),
      transformUnitFn: (value: number) => Number((value / 1000).toFixed(2))
    }
  }
];

export const chartDeviceAttributes: DeviceAttributes[] = [
  ...powerGenerationAttributes,
  {
    scope: [],
    phase: [],
    id: 'P_B_AGGR',
    categoryId: 'default',
    graphOpts: {
      unit: 'kW',
      color: getStyleProp('--green-400'),
      transformUnitFn: (value: number) => Number((value / 1000).toFixed(2)),
      sign: {
        positive: 'P_B_AGGR_POS',
        negative: 'P_B_AGGR_NEG'
      }
    }
  },
  {
    scope: [],
    phase: [],
    id: 'P_EXP',
    categoryId: 'default',
    graphOpts: {
      unit: 'kW',
      color: getStyleProp('--grey-300'),
      transformUnitFn: (value: number) => Number((value / 1000).toFixed(2)),
      sign: {
        positive: 'P_EXP_POS',
        negative: 'P_EXP_NEG',
      },
    }
  },
  {
    scope: [],
    phase: [],
    id: 'P_LOAD',
    categoryId: 'default',
    graphOpts: {
      unit: 'kW',
      color: getStyleProp('--blue-500'),
      transformUnitFn: (value: number) => Number((value / 1000).toFixed(2))
    }
  },
  {
    scope: [],
    phase: [],
    id: 'BP',
    categoryId: 'default',
    graphOpts: {
      unit: '%',
      color: getStyleProp('--green-400'),
      noArea: true
    }
  }, {
    scope: [],
    phase: [],
    id: 'BP1',
    categoryId: 'default',
    graphOpts: {
      unit: '%',
      color: getStyleProp('--green-400'),
      noArea: true
    }
  }, {
    scope: [],
    phase: [],
    id: 'BP2',
    categoryId: 'default',
    graphOpts: {
      unit: '%',
      color: getStyleProp('--green-500'),
      noArea: true
    }
  },
];

export const chartPlantAttributes: DeviceAttributes[] = [
  ...powerGenerationAttributes,
  {
    scope: [],
    phase: [],
    id: 'P_B_AGGR',
    categoryId: 'default',
    graphOpts: {
      unit: 'kW',
      color: getStyleProp('--green-400'),
      transformUnitFn: (value: number) => Number((value / 1000).toFixed(2)),
      sign: {
        positive: 'P_B_AGGR_POS',
        negative: 'P_B_AGGR_NEG'
      }
    }
  },
  {
    scope: [],
    phase: [],
    id: 'P_EXP',
    categoryId: 'default',
    graphOpts: {
      unit: 'kW',
      color: getStyleProp('--grey-300'),
      transformUnitFn: (value: number) => Number((value / 1000).toFixed(2)),
      sign: {
        positive: 'P_EXP_POS',
        negative: 'P_EXP_NEG',
      },
    }
  },
  {
    scope: [],
    phase: [],
    id: 'P_LOAD',
    categoryId: 'default',
    graphOpts: {
      unit: 'kW',
      color: getStyleProp('--blue-500'),
      transformUnitFn: (value: number) => Number((value / 1000).toFixed(2))
    }
  },
  {
    scope: [],
    phase: [],
    id: 'SOL_IRR',
    categoryId: 'solarimeter',
    graphOpts: {
      unit: 'W/m²',
      color: getStyleProp('--yellow-500'),
      noArea: true,
    }
  },
  {
    scope: [],
    phase: [],
    id: 'SOL_TEMP',
    categoryId: 'solarimeter',
    graphOpts: {
      unit: '°C',
      color: getStyleProp('--red-400'),
      noArea: true,
    }
  }
];
